<template>
    <PopoverRight ref="popoverMenu" width="600px">
        <div class="popover-slider-bar">
            <h1 class="bar-title">{{formInfo.id ? "编辑":"新增"}}组合条件页面TDK</h1>
            <p class="remark">1、动态取值字段请用[标签名]表示，如[城市] 在长沙站生成TDK内容时展示为：长沙，广州站生成时展示为：广州。</p>
            <p class="remark">2、支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib" style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span>  进行查看。</p>
            <el-form class="form-container" :model="formInfo" :rules="infoRules" ref="infoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">条件选择</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="condition">
                            <el-checkbox-group v-model="checkConList" @change="conChange">
                                <el-checkbox v-for="(item,index) in conList" :key="index" :label="item.value" :disabled="item.disabled">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">标题</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="title">
                            <el-input placeholder="不超过999个字符" v-model="formInfo.title">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">描述</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="description">
                            <el-input type="textarea" :rows="2" placeholder="不超过999个字符" v-model="formInfo.description">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">关键词</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="keywords">
                            <el-input placeholder="可添加多个关键词，关键词之间用','间隔" v-model="formInfo.keywords">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                    <el-button type="primary" v-preventReClick @click="submitForm('infoForm')">保 存</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
    import PopoverRight from '@/components/popoverRight/index'
    import {getPageTdksDetail,editPageTdks,creatPageTdks} from '@/service/tdkManage'

    export default {
        name:"groupEdit",
        components:{
            PopoverRight
        },
        props: {
            callback: Function,
        },
        data(){
            return {
                checkConList:[],
                formInfo:{
                    title:"",
                    keywords:"",
                    description:"",
                    page_name:"",
                    condition:"",
                    condition_page_type:"2"
                },
                infoRules:{
                    title: [
                        { required: true, message:'标题不能为空', trigger: 'blur' },
                        { min:0,max:999,message:'不超过999字符',trigger: "blur"}
                    ],
                    description:[
                        { required: true, message:'描述不能为空', trigger: 'blur' },
                        { min:0,max:999,message:'不超过999字符',trigger: "blur"}
                    ],
                    keywords:[
                        { required: true, message:'关键词不能为空', trigger: 'blur'},
                        { min:0,max:999,message:'不超过999字符',trigger: "blur"}
                    ],
                    condition:[
                        { required: true, message:'组合条件不能为空', trigger: 'blur'},
                    ]
                
                },
                conList:[{
                    type:"state",
                    disabled:false,
                    name:"优惠楼盘",
                    value:"is_preferential"
                },{
                    type:"state",
                    disabled:false,
                    name:"最近开盘",
                    value:"opening_time"
                },
                // {
                //     type:"state",
                //     disabled:false,
                //     name:"在售楼盘",
                //     value:"on_sale"
                // },
                {
                    type:"state",
                    disabled:false,
                    name:"临地铁",
                    value:"is_near_subway"
                },{
                    type:"location",
                    disabled:false,
                    name:"按区域",
                    value:"district"
                },{
                    type:"location",
                    disabled:false,
                    name:"按片区",
                    value:"section"
                },{
                    type:"location",
                    disabled:false,
                    name:"按地铁线路",
                    value:"subway"
                },{
                    type:"location",
                    disabled:false,
                    name:"按地铁站点",
                    value:"subway_station"
                },{
                    type:"price",
                    disabled:false,
                    name:"价格",
                    value:"price"
                },{
                    type:"area",
                    disabled:false,
                    name:"建面",
                    value:"area"
                },{
                    type:"layout",
                    disabled:false,
                    name:"户型",
                    value:"layout"
                },{
                    type:"type_id",
                    disabled:false,
                    name:"物业",
                    value:"type_id"
                },{
                    type:"sale_info",
                    disabled:false,
                    name:"状态",
                    value:"sale_info"
                },{
                    type:"feature",
                    disabled:false,
                    name:"特色",
                    value:"feature"
                }],

            }
        },
        methods:{
            open(info) {
                this.checkConList = [];
                if(info && info.id){
                    this.conList.forEach(item => {
                            item.disabled = true;
                    })
                    getPageTdksDetail(info.id).then(res => {
                        this.formInfo = res
                        this.formInfo.condition = this.formInfo.condition_page_url
                        this.checkConList = res.condition_page_url.split("@")
                    })
                }
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide() {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.resetForm()
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            submitForm(formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        if(this.formInfo.id){
                            editPageTdks(this.formInfo.id,this.formInfo).then((data) => {
                                this.$message({
                                    message: '编辑成功',
                                    type: 'success',
                                    duration: 3 * 1000
                                })
                                this.hide()
                                this.callback && this.callback();
                            }).catch(err => {
                                this.$message({
                                    message: err.message || '编辑失败',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                            })
                        }else{
                            if(this.checkConList.length < 2){
                                this.$message({
                                    message: '至少选择2个条件才可保存',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                                return;
                            }
                            this.formInfo.page_type = 2;
                            creatPageTdks(this.formInfo).then((data) => {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success',
                                    duration: 3 * 1000
                                })
                                this.hide()
                                this.callback && this.callback();
                            }).catch(err => {
                                this.$message({
                                    message: err.message || '添加失败',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                            })
                        }
                    } else {

                        return false
                    }
                })
            },
            resetForm(){
                this.formInfo={
                    title:"",
                    keywords:"",
                    description:"",
                    page_name:"",
                    condition:"",
                    condition_page_type:"2"
                }
                this.conList.forEach(item => {
                    item.disabled = false;
                })
            },
            showTagLib(){
                this.$emit("showTagLib")
            },
            conChange(){
                let checklist = [];
                this.conList.forEach(item => {
                        item.disabled = false;
                })
                this.checkConList.forEach((value,index)=>{
                    if(value == "section" && this.checkConList.indexOf("district") == -1){
                        this.checkConList.push("district")
                    }else if(value == "subway_station" && this.checkConList.indexOf("subway") == -1){
                        this.checkConList.push("subway")

                    }
                })
                this.conList.forEach(item => {
                    this.checkConList.forEach((value,index)=>{
                        if(value == item.value){
                            checklist.push(item)
                        }
                    })
                })
                checklist.forEach(el => {
                    this.conList.forEach(item => {
                        if(el.type == item.type && el.value != item.value){
                           item.disabled = true;
                        }else if(el.type == item.type && el.value == item.value){
                            item.disabled = false;
                        }
                    })
                });
                this.formInfo.page_name = checklist.map(item => item.name).join("+")
                this.formInfo.condition = checklist.map(item => item.value).join("@")
            }
        }
    }
</script>
<style scoped>
.remark{
    font-size: 14px;
    padding-top: 10px;
    line-height:30px;
    color: #666;
}
</style>